import * as React from "react";
const ReactMarkdown = React.lazy(() => import("react-markdown"));
import { ICompassMessage as CompassMessageType } from "../../types/compass.types";
import { Loader } from "lucide-react";
import { formatTimestamp } from "@/lib/utils";

interface CompassMessageProps {
  type: "user" | "assistant";
  message: CompassMessageType;
}

const CompassMessage: React.FC<CompassMessageProps> = ({ type, message }) => {
  const isUser = type === "user";

  return (
    <div className={`flex flex-col w-full ${isUser ? "items-end" : "items-start"}`}>
      <div
        className={`px-4 py-3 rounded-lg text-sm min-w-[150px] max-w-11/12 flex flex-col gap-2 ${isUser ? "bg-primary-100 text-neutral-400" : "bg-neutral-700 text-neutral-200"
          }`}
      >
        {message.isLoading ? (
          <Loader className="animate-spin" />
        ) : isUser ? (
          <React.Fragment>
            {message.text}
            {message.creation_date && (
              <div className="text-xs text-neutral-500 mt-1 self-end">
                {formatTimestamp(message.creation_date)}
              </div>
            )}
          </React.Fragment>
        ) : (
          <React.Fragment>
            <div className="flex-1 prose prose-sm prose-li:marker:text-neutral-200 max-w-none">
              <React.Suspense fallback={<Loader className="animate-spin" />}>
                <ReactMarkdown
                  components={{
                    a: ({ node, ...props }) => (
                      <a {...props} target="_blank" rel="noopener noreferrer" />
                    ),
                  }}
                >
                  {message.text}
                </ReactMarkdown>
              </React.Suspense>
            </div>
            {message.creation_date && (
              <div className="text-xs text-neutral-500 mt-2 self-start">
                {formatTimestamp(message.creation_date)}
              </div>
            )}
          </React.Fragment>
        )}
      </div>
    </div>
  );
};

export default CompassMessage;
